import { render, staticRenderFns } from "./person-detail-info.html?vue&type=template&id=e0f51bd6&scoped=true&external"
import script from "./person-detail-info.js?vue&type=script&lang=js&external"
export * from "./person-detail-info.js?vue&type=script&lang=js&external"
import style0 from "./person-detail-info.scss?vue&type=style&index=0&id=e0f51bd6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f51bd6",
  null
  
)

export default component.exports